(function () {
  'use strict';

  console.log('[TH Tracking] Script loaded');

  var currentParams = new URLSearchParams(window.location.search);

  console.group('[TH Tracking] Available URL Params');

  if ([...currentParams.keys()].length === 0) {
    console.log('No URL params found');
  } else {
    currentParams.forEach(function(value, key) {
      console.log(key + ':', value);
    });
  }

  console.groupEnd();

  console.group('[TH Tracking] Available Cookies');

  if (!document.cookie) {
    console.log('No cookies found');
  } else {
    document.cookie.split(';').forEach(function(cookie) {
      console.log(cookie.trim());
    });
  }

  console.groupEnd();

  var PARAM_KEYS = [
    'ref',
    'attr_signup_ref_code_text',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'glid',
    'fbclid'
  ];

  console.group('[TH Tracking] Supported Params Check');

  PARAM_KEYS.forEach(function(key) {
    var value = currentParams.get(key);

    if (value) {
      console.log('FOUND:', key, '=', value);
    } else {
      console.log('MISSING:', key);
    }
  });

  console.groupEnd();

  function getCookie(name) {
    var m = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );

    var value = m ? decodeURIComponent(m[1]) : null;

    console.log('[TH Tracking] Cookie lookup:', name, value);

    return value;
  }

  function buildDecoratedUrl(originalHref) {
    console.log('[TH Tracking] Original href:', originalHref);

    var url = new URL(originalHref);

    var addedParams = {};
    var skippedParams = {};
    var missingParams = {};

    PARAM_KEYS.forEach(function(key) {
      var value = currentParams.get(key);

      if (value && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
        addedParams[key] = value;

        console.log('[TH Tracking] Added URL param:', key, value);
      } else if (value && url.searchParams.has(key)) {
        skippedParams[key] = url.searchParams.get(key);

        console.log(
          '[TH Tracking] Skipped URL param because CTA already has it:',
          key,
          url.searchParams.get(key)
        );
      } else {
        missingParams[key] = null;
      }
    });

    var edgetagId = getCookie('tag_user_id');

    if (edgetagId && !url.searchParams.has('edgetag_id')) {
      url.searchParams.set('edgetag_id', edgetagId);
      addedParams.edgetag_id = edgetagId;

      console.log('[TH Tracking] Added EdgeTag ID:', edgetagId);
    } else if (edgetagId && url.searchParams.has('edgetag_id')) {
      skippedParams.edgetag_id = url.searchParams.get('edgetag_id');

      console.log(
        '[TH Tracking] Skipped EdgeTag ID because CTA already has it:',
        url.searchParams.get('edgetag_id')
      );
    }

    var fbp = getCookie('_fbp');

    if (fbp && !url.searchParams.has('fbp')) {
      url.searchParams.set('fbp', fbp);
      addedParams.fbp = fbp;

      console.log('[TH Tracking] Added _fbp as fbp:', fbp);
    } else if (fbp && url.searchParams.has('fbp')) {
      skippedParams.fbp = url.searchParams.get('fbp');

      console.log(
        '[TH Tracking] Skipped _fbp because CTA already has fbp:',
        url.searchParams.get('fbp')
      );
    }

    var fbc = getCookie('_fbc');

    if (fbc && !url.searchParams.has('fbc')) {
      url.searchParams.set('fbc', fbc);
      addedParams.fbc = fbc;

      console.log('[TH Tracking] Added _fbc as fbc:', fbc);
    } else if (fbc && url.searchParams.has('fbc')) {
      skippedParams.fbc = url.searchParams.get('fbc');

      console.log(
        '[TH Tracking] Skipped _fbc because CTA already has fbc:',
        url.searchParams.get('fbc')
      );
    }

    console.group('[TH Tracking] Params Added After Click');

    if (Object.keys(addedParams).length === 0) {
      console.log('No params were added');
    } else {
      Object.entries(addedParams).forEach(function(entry) {
        console.log(entry[0] + ':', entry[1]);
      });
    }

    console.groupEnd();

    console.group('[TH Tracking] Params Skipped Because Already Present');

    if (Object.keys(skippedParams).length === 0) {
      console.log('No params were skipped');
    } else {
      Object.entries(skippedParams).forEach(function(entry) {
        console.log(entry[0] + ':', entry[1]);
      });
    }

    console.groupEnd();

    console.group('[TH Tracking] Supported Params Missing From Page URL');

    if (Object.keys(missingParams).length === 0) {
      console.log('No supported params were missing');
    } else {
      Object.keys(missingParams).forEach(function(key) {
        console.log(key);
      });
    }

    console.groupEnd();

    var finalUrl = url.toString();

    console.log('[TH Tracking] Final decorated URL:', finalUrl);

    return finalUrl;
  }

  function logError(err, ctaId) {
    console.error('[TH Tracking] Decoration error:', err);

    try {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'th_link_error',
        error_message: (err && err.message) ? err.message : 'unknown',
        cta_id: ctaId || 'unknown',
        page_location: window.location.href
      });

      console.log('[TH Tracking] Error pushed to dataLayer');
    } catch (e) {
      console.error('[TH Tracking] Failed pushing to dataLayer:', e);
    }
  }

  function handleClick(event) {
    var link = event.target.closest('a[data-decorate-url="true"]');

    if (!link || !link.href) return;

    console.log('[TH Tracking] CTA clicked:', {
      cta_id: link.getAttribute('data-cta-id'),
      original_href: link.href
    });

    try {
      link.href = buildDecoratedUrl(link.href);

      console.log('[TH Tracking] Updated href applied:', link.href);
    } catch (err) {
      console.warn(
        '[TH Tracking] URL decoration failed, using original href:',
        err
      );

      logError(err, link.getAttribute('data-cta-id'));
    }
  }

  document.addEventListener('click', handleClick, true);

  console.log('[TH Tracking] Click listener attached');

  window.IntimateRoseTracking = window.IntimateRoseTracking || {};
  window.IntimateRoseTracking.buildDecoratedUrl = buildDecoratedUrl;

  console.log('[TH Tracking] Global helper attached');

})();


(function () {
  'use strict';

  console.log('[TH Tracking] Script loaded');

  var currentParams = new URLSearchParams(window.location.search);

  console.group('[TH Tracking] Available URL Params');

  if ([...currentParams.keys()].length === 0) {
    console.log('No URL params found');
  } else {
    currentParams.forEach(function (value, key) {
      console.log(key + ':', value);
    });
  }

  console.groupEnd();

  console.group('[TH Tracking] Available Cookies');

  if (!document.cookie) {
    console.log('No cookies found');
  } else {
    document.cookie.split(';').forEach(function (cookie) {
      console.log(cookie.trim());
    });
  }

  console.groupEnd();

  var PARAM_KEYS = [
    'ref',
    'attr_signup_ref_code_text',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'glid',
    'fbclid'
  ];

  console.group('[TH Tracking] Supported Params Check');

  PARAM_KEYS.forEach(function (key) {
    var value = currentParams.get(key);

    if (value) {
      console.log('FOUND:', key, '=', value);
    } else {
      console.log('MISSING:', key);
    }
  });

  console.groupEnd();

  function getCookie(name) {
    var escapedName = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');

    var m = document.cookie.match(
      new RegExp('(?:^|; )' + escapedName + '=([^;]*)')
    );

    var value = m ? decodeURIComponent(m[1]) : null;

    console.log('[TH Tracking] Cookie lookup:', name, value);

    return value;
  }

  function setCookie(name, value) {
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=31536000; SameSite=Lax; Secure';

    console.log('[TH Tracking] Cookie set:', name, value);
  }

  function getLocalStorageValue(key) {
    try {
      var value = localStorage.getItem(key);

      console.log('[TH Tracking] localStorage lookup:', key, value);

      return value;
    } catch (e) {
      console.warn('[TH Tracking] localStorage unavailable:', key, e);
      return null;
    }
  }

  function setLocalStorageValue(key, value) {
    try {
      localStorage.setItem(key, value);
      console.log('[TH Tracking] localStorage set:', key, value);
    } catch (e) {
      console.warn('[TH Tracking] Failed setting localStorage:', key, e);
    }
  }

  function createTrackingId() {
    var randomPart = Math.random().toString(36).substring(2, 12);

    var newId =
      'tbh_' +
      Date.now() +
      '_' +
      randomPart;

    console.log('[TH Tracking] New tracking ID created:', newId);

    return newId;
  }

  function getOrCreateTrackingId() {
    var fromUrl = currentParams.get('edgetag_id');

    if (fromUrl) {
      console.log('[TH Tracking] Found tracking ID from URL:', fromUrl);

      setCookie('tag_user_id', fromUrl);
      setLocalStorageValue('tag_user_id', fromUrl);
      setLocalStorageValue('edgetag_id', fromUrl);

      return fromUrl;
    }

    var fromCookie = getCookie('tag_user_id');

    if (fromCookie) {
      console.log('[TH Tracking] Found tracking ID from cookie:', fromCookie);

      setLocalStorageValue('tag_user_id', fromCookie);
      setLocalStorageValue('edgetag_id', fromCookie);

      return fromCookie;
    }

    var fromLocalStorage =
      getLocalStorageValue('tag_user_id') ||
      getLocalStorageValue('edgetag_id');

    if (fromLocalStorage) {
      console.log('[TH Tracking] Found tracking ID from localStorage:', fromLocalStorage);

      setCookie('tag_user_id', fromLocalStorage);

      return fromLocalStorage;
    }

    var newId = createTrackingId();

    setCookie('tag_user_id', newId);
    setLocalStorageValue('tag_user_id', newId);
    setLocalStorageValue('edgetag_id', newId);

    return newId;
  }

  function buildDecoratedUrl(originalHref) {
    console.log('[TH Tracking] Original href:', originalHref);

    var url = new URL(originalHref);

    var addedParams = {};
    var skippedParams = {};
    var missingParams = {};

    PARAM_KEYS.forEach(function (key) {
      var value = currentParams.get(key);

      if (value && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
        addedParams[key] = value;

        console.log('[TH Tracking] Added URL param:', key, value);
      } else if (value && url.searchParams.has(key)) {
        skippedParams[key] = url.searchParams.get(key);

        console.log(
          '[TH Tracking] Skipped URL param because CTA already has it:',
          key,
          url.searchParams.get(key)
        );
      } else {
        missingParams[key] = null;
      }
    });

    var edgetagId = getOrCreateTrackingId();

    if (edgetagId && !url.searchParams.has('edgetag_id')) {
      url.searchParams.set('edgetag_id', edgetagId);
      addedParams.edgetag_id = edgetagId;

      console.log('[TH Tracking] Added EdgeTag ID:', edgetagId);
    } else if (edgetagId && url.searchParams.has('edgetag_id')) {
      skippedParams.edgetag_id = url.searchParams.get('edgetag_id');

      console.log(
        '[TH Tracking] Skipped EdgeTag ID because CTA already has it:',
        url.searchParams.get('edgetag_id')
      );
    }

    var fbp = getCookie('_fbp');

    if (fbp && !url.searchParams.has('fbp')) {
      url.searchParams.set('fbp', fbp);
      addedParams.fbp = fbp;

      console.log('[TH Tracking] Added _fbp as fbp:', fbp);
    } else if (fbp && url.searchParams.has('fbp')) {
      skippedParams.fbp = url.searchParams.get('fbp');

      console.log(
        '[TH Tracking] Skipped _fbp because CTA already has fbp:',
        url.searchParams.get('fbp')
      );
    }

    var fbc = getCookie('_fbc');

    if (fbc && !url.searchParams.has('fbc')) {
      url.searchParams.set('fbc', fbc);
      addedParams.fbc = fbc;

      console.log('[TH Tracking] Added _fbc as fbc:', fbc);
    } else if (fbc && url.searchParams.has('fbc')) {
      skippedParams.fbc = url.searchParams.get('fbc');

      console.log(
        '[TH Tracking] Skipped _fbc because CTA already has fbc:',
        url.searchParams.get('fbc')
      );
    }

    console.group('[TH Tracking] Params Added After Click');

    if (Object.keys(addedParams).length === 0) {
      console.log('No params were added');
    } else {
      Object.entries(addedParams).forEach(function (entry) {
        console.log(entry[0] + ':', entry[1]);
      });
    }

    console.groupEnd();

    console.group('[TH Tracking] Params Skipped Because Already Present');

    if (Object.keys(skippedParams).length === 0) {
      console.log('No params were skipped');
    } else {
      Object.entries(skippedParams).forEach(function (entry) {
        console.log(entry[0] + ':', entry[1]);
      });
    }

    console.groupEnd();

    console.group('[TH Tracking] Supported Params Missing From Page URL');

    if (Object.keys(missingParams).length === 0) {
      console.log('No supported params were missing');
    } else {
      Object.keys(missingParams).forEach(function (key) {
        console.log(key);
      });
    }

    console.groupEnd();

    var finalUrl = url.toString();

    console.log('[TH Tracking] Final decorated URL:', finalUrl);

    return finalUrl;
  }

  function logError(err, ctaId) {
    console.error('[TH Tracking] Decoration error:', err);

    try {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'th_link_error',
        error_message: err && err.message ? err.message : 'unknown',
        cta_id: ctaId || 'unknown',
        page_location: window.location.href
      });

      console.log('[TH Tracking] Error pushed to dataLayer');
    } catch (e) {
      console.error('[TH Tracking] Failed pushing to dataLayer:', e);
    }
  }

  function handleClick(event) {
    var link = event.target.closest('a[data-decorate-url="true"]');

    if (!link || !link.href) return;

    console.log('[TH Tracking] CTA clicked:', {
      cta_id: link.getAttribute('data-cta-id'),
      original_href: link.href
    });

    try {
      link.href = buildDecoratedUrl(link.href);

      console.log('[TH Tracking] Updated href applied:', link.href);
    } catch (err) {
      console.warn(
        '[TH Tracking] URL decoration failed, using original href:',
        err
      );

      logError(err, link.getAttribute('data-cta-id'));
    }
  }

  document.addEventListener('click', handleClick, true);

  console.log('[TH Tracking] Click listener attached');

  window.IntimateRoseTracking = window.IntimateRoseTracking || {};
  window.IntimateRoseTracking.buildDecoratedUrl = buildDecoratedUrl;
  window.IntimateRoseTracking.getOrCreateTrackingId = getOrCreateTrackingId;

  console.log('[TH Tracking] Global helper attached');
})();